import { render } from "./BulkMailModal.vue?vue&type=template&id=62aefdbe&scoped=true"
import script from "./BulkMailModal.vue?vue&type=script&lang=js"
export * from "./BulkMailModal.vue?vue&type=script&lang=js"

import "./BulkMailModal.vue?vue&type=style&index=0&id=62aefdbe&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\SPNM\\Core\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62aefdbe"]])

export default __exports__